export default __webpack_public_path__ + "static/media/quatation.69cb6771.svg";